import { makeBooleanVar } from 'src/utils/makeVar.utils';

export const {
  hook: useBoardConfigAnalytics,
  get: getBoardConfigAnalytics,
  toggle: toggleBoardConfigAnalytics,
  setTrue: setBoardConfigAnalyticsOpen,
  setFalse: setBoardConfigAnalyticsClose,
} = makeBooleanVar(false);
